import {  } from "@fortawesome/pro-light-svg-icons";
import { GenericStatus } from "./props";
import { faCheckCircle, faXmarkCircle, faClock } from "@fortawesome/pro-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const IncomePaymentStatus: GenericStatus[] = [
    {key: "pending", text: "Pending approval", icon: faClock as IconProp, tagVariant: 'warning'},
    {key: "financeconfirmed", text: "Confirmed by finance", icon: faCheckCircle as IconProp, tagVariant: 'primary'},
    {key: "verified", text: "Verified", icon: faCheckCircle as IconProp, tagVariant: 'success'},
    {key: "rejected", text: "Rejected", icon: faXmarkCircle as IconProp, tagVariant: 'error'}
]

export default IncomePaymentStatus;